import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=0eeb9e40&scoped=true"
import script from "./CourseVideo.vue?vue&type=script&lang=js"
export * from "./CourseVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeb9e40",
  null
  
)

export default component.exports